import React from "react";
import { motion } from "framer-motion";
import TagVisual from "./TagVisual";

const callouts = [
  { title: "Listens for you", desc: "A calm, ambient presence — ready when you need it.", pos: "top-[5%] left-[2%]" },
  { title: "Answers back", desc: "A gentle sound response guides you to its spot.", pos: "top-[5%] right-[2%]" },
  { title: "Attaches anywhere", desc: "Keys, wallet, remote, bag — wherever it belongs.", pos: "bottom-[12%] left-[2%]" },
  { title: "Feels alive", desc: "Not a tracker. A tiny companion for your things.", pos: "bottom-[12%] right-[2%]" },
];

const ProductCallout = () => {
  return (
    <section
      id="product"
      data-testid="product-callout-section"
      className="relative py-28 md:py-36 bg-white overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.2em] uppercase text-blue-600 font-medium">The Object</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl font-semibold tracking-tight">
            Small, quiet, <span className="italic font-light text-zinc-500">responsive</span>.
          </h2>
          <p className="mt-5 text-zinc-600 text-lg leading-relaxed">
            Designed to disappear into your day — until you call it.
          </p>
        </div>

        <div className="relative mt-20 rounded-[36px] bg-gradient-to-b from-zinc-50 to-white border border-zinc-200/60 p-8 md:p-16 overflow-hidden">
          <div className="absolute inset-0 glow-silver opacity-40 blur-3xl" />
          <div className="absolute -top-40 -right-40 w-96 h-96 glow-blue opacity-40 blur-3xl" />

          <div className="relative flex items-center justify-center min-h-[420px] md:min-h-[520px]">
            <TagVisual size={380} listening />

            {callouts.map((c, i) => (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className={`hidden md:block absolute ${c.pos} max-w-[220px]`}
                data-testid={`callout-${i}`}
              >
                <div className="glass rounded-2xl px-4 py-3">
                  <div className="text-sm font-semibold tracking-tight">{c.title}</div>
                  <div className="text-xs text-zinc-600 mt-1 leading-snug">{c.desc}</div>
                </div>
                <div className={`absolute top-1/2 ${c.pos.includes("left") ? "right-[-28px]" : "left-[-28px]"} w-7 h-px bg-gradient-to-r from-zinc-300 to-transparent`} />
              </motion.div>
            ))}
          </div>

          <div className="md:hidden grid grid-cols-2 gap-3 mt-6">
            {callouts.map((c) => (
              <div key={c.title} className="glass rounded-2xl p-3">
                <div className="text-sm font-semibold tracking-tight">{c.title}</div>
                <div className="text-xs text-zinc-600 mt-1">{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductCallout;
